import classNames from 'classnames';
import React, { PropsWithChildren, ReactElement } from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import { TableRowProps } from 'react-table';
import styles from './index.module.css';

type DraggableContainerProps = PropsWithChildren<
  Partial<DraggableProvided> & TableRowProps & { isDragging: boolean }
>;

export function DraggableContainer({
  isDragging,
  children,
  className,
  innerRef,
  ...rest
}: DraggableContainerProps): ReactElement {
  const classes = classNames(className, [styles.root], {
    [styles.isDragging]: isDragging,
  });

  return (
    <div ref={innerRef} className={classes} {...rest}>
      {children}
    </div>
  );
}
